module.exports = __webpack_public_path__ + "assets/img/bla2.0f48e1dc.png";